import { type ScoringSystemMetricAttributes } from './generated/ScoringSystemMetricAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import { underscore } from 'inflected';

interface ScoringSystemMetric extends ScoringSystemMetricAttributes {}

@model
class ScoringSystemMetric extends ApplicationModel {
  // Start auto-generated
  static typename: 'ScoringSystemMetric' = 'ScoringSystemMetric';
  get typename(): 'ScoringSystemMetric' {
    return 'ScoringSystemMetric';
  }

  static internalTypename: 'ScoringSystemMetric' = 'ScoringSystemMetric';
  get internalTypename(): 'ScoringSystemMetric' {
    return 'ScoringSystemMetric';
  }

  static fields = {
    controlType: attr({ readable: true }),
    equation: attr({ readable: true }),
    equationDefaultValue: attr({ readable: true }),
    equationRecordClasses: attr({ readable: true }),
    equationStructure: attr({ readable: true, json: true }),
    id: attr({ readable: true }),
    maximumValue: attr({ readable: true }),
    minimumValue: attr({ readable: true }),
    name: attr({ readable: true }),
    position: attr({ readable: true }),
    prefixUnits: attr({ readable: true }),
    scoringSystemId: attr({ readable: true }),
    sequenceType: attr({ readable: true }),
    sequenceValues: attr({ readable: true }),
    stepValue: attr({ readable: true }),
    units: attr({ readable: true }),
    value: attr({ readable: true }),
    values: attr({ readable: true }),
    weight: attr({ readable: true }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
  };
  // End auto-generated

  // The ScoreSetter component expects scoring system metrics to have underscored attributes
  get underscoredAttributes() {
    const allAttrs = Array.from(
      this.modelConstructor.selectAll().attrs.values()
    );

    const out = {};
    allAttrs.forEach(attr => (out[underscore(attr)] = this.attributes[attr]));
    return out;
  }
}

export default ScoringSystemMetric;
